import axios from "../axiosInstance";
import type {
  UpdateLibraryModuleRequest,
  LibraryModule,
} from "@/modules/learningCenter/features/ModuleLibrary/types/libraryModule.types";

/**
 * Update an existing library module
 */
export const updateLibraryModule = async (
  id: number,
  data: UpdateLibraryModuleRequest
): Promise<LibraryModule> => {
  const response = await axios.put<LibraryModule>(
    `/api/learning-center/module-library/${id}`,
    data
  );
  return response.data;
};

export default updateLibraryModule;
